import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ApiFactoryService} from '../../shared/services/api-factory.service';
import {AbstractBffApi, HelpSectionInterface} from '../../models/sharedinterface';
import {ShareddataService} from '../../shared/services/shareddata.service';
import {I18nService} from '../../shared/services/i18n.service';

@Component({
  selector: 'app-helpview',
  templateUrl: './helpview.component.html',
  styleUrls: ['./helpview.component.scss']
})
export class HelpviewComponent implements OnInit {

  helpData: HelpSectionInterface[];

  bffapi: AbstractBffApi;

  @Output() closeHelpSidebar: EventEmitter<any> = new EventEmitter();

  @Input() helpId?: number;

  constructor(private apifactory: ApiFactoryService,
              private shareddata: ShareddataService,
              public i18n: I18nService) {

    this.bffapi = this.apifactory.createBffApi();

    // References shared data
    this.shareddata.sharedhelpdata$.subscribe((data) => {
      this.helpData = data.sort((a, b) => a.sort > b.sort ? 1 : -1);
    });

    // Fetches help data
    const languagekey = this.shareddata.getCurrentlanguage().key;
    const query = this.bffapi.gethelp(languagekey);
    query.subscribe((response) => {
      this.shareddata.setSharedhelpdata(response.results);
    });

  }

  ngOnInit(): void {}

  closeHelp() {
    this.closeHelpSidebar.emit();
  }
}
